import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F3FBF9",
    color: "#B1B4BC",
    height: "50px",
    padding: "0px 16px 0px 16px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function AddUser({
  open,
  handleClose,
  handleForwarded,
  forwarded,
  removeAnswer,
  allUsers,
  currentUseCase,
  idUseCase,
  setProgression,
  progression,
}) {
  const { t } = useTranslation();

  const storedUser = localStorage.getItem("user");
  const orgaId = useSelector((state) => state.organizationProfile.id);
  const accountType = JSON.parse(storedUser)?.account_type;

  const [search, setSearch] = useState("");


  const isMobile = useMediaQuery("(max-width:1400px)");

  const handleUser = (email, fullName) => {
    handleForwarded([
      ...forwarded,
      {
        fullName: fullName,
        email: email,
        usecase_id: idUseCase,
        threshold: 0,
        title: currentUseCase?.title,
        title_fr: currentUseCase?.title_fr,
      },
    ]);
    removeAnswer(currentUseCase);
    if (progression.includes(idUseCase)) {
      setProgression(progression.filter((el) => el !== idUseCase));
    }
    handleClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
          setSearch("");
        }}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "55%", padding: "20px" }
            : { width: "90%", height: "80%", margin: "5px 0", padding: "5px " },
        }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 1 }}
        >
          <IconButton
            onClick={() => {
              handleClose();
              setSearch("");
            }}
          >
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <DialogTitle>
          <Typography variant="title4">{t("select_user")}</Typography>
        </DialogTitle>
        <DialogContent>
          <TableContainer
            component={Paper}
            className="scrollhost"
            sx={{
              width: "100%",
              "&.MuiTableContainer-root": {
                borderRadius: "0px",
                boxShadow: "none",
              },
              mt: !isMobile ? 3 : 0,
            }}
          >
            <Table
              stickyHeader
              aria-label="customized table"
              sx={{
                width: "100%",
                "& .MuiTableRow-root:hover": {
                  backgroundColor: "#DDF6F0",
                  cursor: "pointer",
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    align="left"
                    width={accountType === "enterprise" ? "20%" : "40%"}
                  >
                    {t("name")}
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    width={accountType === "enterprise" ? "20%" : "30%"}
                  >
                    {t("email")}
                  </StyledTableCell>
                  {accountType === "enterprise" && (
                    <StyledTableCell align="center" width="30%">
                      {t("role")}
                    </StyledTableCell>
                  )}
                  <StyledTableCell align="center" width="30%"></StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {allUsers?.map((el) => (
                  <StyledTableRow
                    key={el.id}
                    onClick={() =>
                      handleUser(el.email, `${el?.first_name} ${el?.last_name}`)
                    }
                  >
                    <StyledTableCell align="left">
                      {`${el?.first_name} ${el?.last_name}`}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {el?.email}
                    </StyledTableCell>
                    {accountType === "enterprise" && (
                      <StyledTableCell align="center">
                        {t(el?.role)}
                      </StyledTableCell>
                    )}
                    <StyledTableCell
                      align="center"
                      sx={{
                        color: el?.status ? "#78c3ae" : "rgb(209, 67, 67)",
                        fontSize: "5px",
                      }}
                    >
                      {el?.status ? t("user_confirmed") : t("user_pending")}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
}
